var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-field-div", class: _vm.defineDivSize },
    [
      _c(
        "div",
        { staticClass: "form-label-div", class: { disabled: _vm.disabled } },
        [
          _c("label", { attrs: { for: _vm.id } }, [
            _vm._v(_vm._s(_vm.$tc(_vm.label, 1)))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "form-input-span",
          class: {
            noUnderline: _vm.inputType === "checkbox",
            disabled: _vm.disabled
          }
        },
        [
          _vm.inputType === undefined || _vm.inputType === "input"
            ? _c("input", {
                staticClass: "form-input",
                class: {
                  defineInputSize: _vm.defineInputSize,
                  "hide-arrow": _vm.hideArrow
                },
                attrs: {
                  type: _vm.defineType,
                  id: _vm.id,
                  placeholder: _vm.placeholder,
                  spellcheck: "false",
                  disabled: _vm.disabled,
                  autofocus: ""
                },
                domProps: { value: _vm.value },
                on: {
                  input: function($event) {
                    return _vm.emitInput($event.target.value)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.inputType === "textarea"
            ? _c("textarea", {
                staticClass: "form-input",
                class: _vm.defineInputSize,
                attrs: {
                  id: _vm.id,
                  placeholder: _vm.placeholder,
                  spellcheck: "false",
                  disabled: _vm.disabled
                },
                domProps: { value: _vm.value },
                on: {
                  input: function($event) {
                    return _vm.emitInput($event.target.value)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.inputType === "select" ||
          _vm.inputType === "datepicker" ||
          _vm.inputType === "checkbox"
            ? _vm._t("default")
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-180c4346", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180c4346","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/FormInput.vue
// module id = null
// module chunks = 